import { Box, Typography } from '@mui/material';
import { useMemo } from 'react';
import FlagIcon from '../../../../../components/Icons/FlagIcon';
import BaseModal from '../../../../../components/MUIComponents/BaseModal';

interface VerificationNotifyModalProps {
  isOpen: boolean;
  onClose: () => void;
  role?: string;
}

const VerificationNotifyModal = ({
  isOpen,
  onClose,
  role,
}: VerificationNotifyModalProps) => {
  const title = useMemo(
    () => (
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
      >
        <Box m="24px 0 36px">
          <FlagIcon />
        </Box>
        <Typography variant="h2">Welcome to Free Agent!</Typography>
      </Box>
    ),
    []
  );

  const bodyText = useMemo(() => {
    if (role === 'COMPANY') {
      return (
        <Typography variant="body2" textAlign="center">
          {`Hang tight — we’re reviewing your company registration as fast as possible.`}
          <br />
          <br />
          {`Please ensure you’ve completed your company details and uploaded any required documents.`}
          <br />
          <br />
          {`We’ll notify you as soon as your account is approved.`}
        </Typography>
      );
    }

    return (
      <Typography variant="body2" textAlign="center">
        {`Hang tight - we’re verifying your ID and sport experience as fast as possible.`}
        <br />
        <br />
        {`We can’t wait for you to join the platform!`}
      </Typography>
    );
  }, [role]);

  return (
    <BaseModal
      boxSx={{ width: '875px', maxHeight: 756, overflowY: 'scroll' }}
      header={{
        component: title,
      }}
      isOpen={isOpen}
      toggle={onClose}
      disableDefaultFooter
    >
      {bodyText}
    </BaseModal>
  );
};

export default VerificationNotifyModal;
